import { Component, OnInit, ViewChild, ElementRef, ViewChildren} from '@angular/core';
import { ServerService } from '../../../shared/services/server.service';
import { ActivatedRoute } from '@angular/router';
import {ISpot} from "../../../shared/models/models";
import { EventService } from '../../../shared/services/event.service';
import { environment } from '../../../../environments/environment';
// import * as EXIF from 'exif-js';
declare var EXIF: any;


@Component({
  selector: 'app-object-gallery',
  templateUrl: './object-gallery.component.html',
  styleUrls: ['./object-gallery.component.scss']
})
export class ObjectGalleryComponent implements OnInit {

  uri = '';

  fileToUpload: File = null;
  albumModal: boolean = false;
  livingComplexId: number;
  loader: boolean = false;
  currentLivingComplexePhoto: boolean = false;
  currentLivingComplexePhotoId;
  imageToShow: any;
  api = environment.apiUrl;
  output;
  orientation: number;
  @ViewChild('myImg', { static: false }) myImg: ElementRef;

  constructor(private serverService: ServerService, private route: ActivatedRoute, private eventService: EventService) { }

  ngOnInit() {

    this.getImage();
    this.getBuildingsByLivingComplexId(this.livingComplexId);
    this.getLastFourImgForLivingComplex(this.livingComplexId);
  }

  getImage() {
    this.route.params.subscribe(params => {
      this.livingComplexId = params.id;
      this.serverService.getObject(this.livingComplexId).then(res => {
        this.currentLivingComplexePhoto = res.photo_id ? true : false;
        this.getImgByUrl();
      });
    });
  }

  livingComplexLoader = false;
  getImgByUrl() {
    if (this.currentLivingComplexePhoto) {
      this.livingComplexLoader = true;
      setTimeout(() => {
        this.uri = this.api + `Files/DownloadLivingComplexFile?LivingComplexID=${this.livingComplexId}&isThumb=false&date=${new Date()}`;
        this.livingComplexLoader = false;
      }, 800);
    } else {
      this.uri = '';
    }
  }

  handleFileInput(files) {
    this.fileToUpload = <File>files.item(0);
    let fileType = this.fileToUpload.type.substr(this.fileToUpload.type.indexOf('/') + 1);
    this.loader = true;
    this.serverService.insertLivingComplexePhoto(this.livingComplexId, fileType, this.fileToUpload).then(res => {
      if (res) {
        this.eventService.updateMainThumbnail.emit(res);
        this.currentLivingComplexePhoto = true;
        this.uri = this.api + `Files/DownloadBuildingFile?fileId=${res}&isThumb=false`;
        this.loader = false;
      }
    });
  }

  allBuildings: ISpot[] = [];
  getBuildingsByLivingComplexId(livingComplexId: number) {
    this.allBuildings = [];
    this.serverService.getBuildingsByLivingComplexId(livingComplexId).then(res => {
      if(res) {
        res.forEach(s => {
          s.spots.stages = s.stages;
          this.allBuildings.push(s.spots);
        });
        this.getAllBuildings(this.allBuildings);
      }
    });
  }

  lastFour: LastEx[] = [];
  getAllBuildings(allBuildings) {
    allBuildings.forEach((item, i) => {
      this.getLastFourImgForBuildings(item.id).then(res => {
        this.lastFour[i] = {
          id: item.id,
          title: item.number,
          album: res
        };
      });
    });
  }

  lastFourLoader = false;
  getLastFourImgForBuildings(buildingId: number) {
    let lastFour: { src: string, srcFalse: string, fileTypeId: number } [] = [];
    let arr = [];
    let lf = [];
    return this.serverService.getAllBuildingsPhotoById(buildingId, null).then(res => {
      res.map(r => { arr.push({ id: r.id, fileTypeId: r.fileTypeID}); });
          if(arr.length > 5) {
          lf = arr.slice(Math.max(arr.length - 4, 1));
          } else { lf = arr; }

          for(let i = 0; i < 4; i++) {
            this.lastFourLoader = true;
            let srcEx = '';
            let srcExFalse = '';
            let typeId: number;
            if(lf[i]) {
                srcEx = this.api + `BuildingFiles/DownloadFile?fileID=${lf[i].id}&isThumb=true`;
                srcExFalse = this.api + `BuildingFiles/DownloadFile?fileID=${lf[i].id}&isThumb=false`;
                typeId = lf[i].fileTypeId;
            } else {
              srcEx = '/assets/icon-genro.png';
            }
            setTimeout(() => {
              lastFour[i] = { src: srcEx, srcFalse: srcExFalse, fileTypeId: typeId };
              this.lastFourLoader = false;
            }, 500);
          }

      return lastFour;
    });
  }

  lastFourImageForLivingComplexLoader = false;
  lastFourImageForLivingComplex: LastFour[] = [];
  allBuildingImage = [];
  getLastFourImgForLivingComplex(livingComplexId) {
    this.lastFourImageForLivingComplex = [];
    this.serverService.getAllBuildingsPhotoById(null, livingComplexId).then(res => {
      this.allBuildingImage = res;
      let arr = [];
      res.map(r => {
        arr.push({ id: r.id, fileTypeId: r.fileTypeID });
      });

      let lf = [];
      if (arr.length > 5) {
        lf = arr.slice(Math.max(arr.length - 4, 1));
      } else {
        lf = arr;
      }
      for (let i = 0; i < 4; i++) {
        this.lastFourImageForLivingComplexLoader = true;
        let srcEx = '';
        let urlEx = '';
        let srcFalseEx  = '';
        let fileTypeIDEx: number = 1;
        let idEx: number;
        if (lf[i]) {
          idEx = lf[i].id;
          urlEx = this.api + `BuildingFiles/DownloadFile?fileID=${lf[i].id}&isThumb=true`;
          fileTypeIDEx = lf[i].fileTypeId;
          srcFalseEx = this.api + `BuildingFiles/DownloadFile?fileID=${lf[i].id}&isThumb=false`;
          srcEx = this.api + `BuildingFiles/DownloadFile?fileID=${lf[i].id}&isThumb=true`
        } else {
          srcEx = '/assets/icon-genro.png';
        }
        setTimeout(() => {
          this.lastFourImageForLivingComplex[i] = {
            id: idEx,
            src: srcEx,
            srcFalse: srcFalseEx,
            url: urlEx,
            type: fileTypeIDEx
          };
          this.lastFourImageForLivingComplexLoader = false;
        }, 500);
      }
    });
  }

  deleteBtn: boolean = false;
  deletePhotoLivingComplex() {
    this.deleteBtn = true;
  }

  // deleteImageLivingComplexById(id: number) {
  //   this.serverService.deleteLivingComplexePhoto(id).then(res => {
  //     if(res) {
  //       this.eventService.updateMainThumbnail.emit('');
  //       this.currentLivingComplexePhoto = false;
  //       this.alertPhoto = false;
  //     }
  //   });
  // }

  alertPhoto = false;
  idForDelete: number;
  openAlert(id: number) {
    this.idForDelete = id;
    this.alertPhoto = true;
  }

  cancelAlert() {
    this.alertPhoto = false;
    this.idForDelete = null;
  }

  openImg = false;
  openImgId: number = 0;
  openImage() {
    this.openImg = true;
    this.getImgByUrl();
  }

  selectAlbumTitle;
  selectAlbum;
  openAlbum(i: number) {
    this.selectAlbum = i;
    this.selectAlbumTitle = this.allBuildings.filter(x => x.id === i)[0].number;
    this.albumModal = !this.albumModal;
  }

  closeAlbum(e) {
    this.albumModal = !this.albumModal;
    this.getImage();
    this.getBuildingsByLivingComplexId(this.livingComplexId);
    this.getLastFourImgForLivingComplex(this.livingComplexId);
  }

  openOneImg = false;
  openOneImgLoader = false;
  selectedOneImg;
  openOnePhoto(item) {
    this.openOneImg = true;
    this.selectedOneImg = item;
  }


  clickedSlider(val: string, selectedImg) {

    let allBuildingsLength = this.allBuildingImage.length - 1;
    let lastFourImageForLivingComplexLength = this.lastFourImageForLivingComplex.length - 1;

    let lengthArr = allBuildingsLength >= lastFourImageForLivingComplexLength ? lastFourImageForLivingComplexLength : allBuildingsLength;

    let index = this.lastFourImageForLivingComplex.findIndex(r => r.id === selectedImg.id);
    let sel;
    if (val === 'right') {
      if (index === lengthArr) {
        sel = this.lastFourImageForLivingComplex[0];
      } else {
        sel = this.lastFourImageForLivingComplex[index + 1];
      }
    }
    if (val === 'left') {
      if (index === 0) {
        sel = this.lastFourImageForLivingComplex[lengthArr];
      } else {
        sel = this.lastFourImageForLivingComplex[index - 1];
      }
    }
    this.openOnePhoto(sel);
  }

  albumClosed(event) {
  }

}


interface LastEx {
  album: LastExInner[];
  id: number;
  title: any;
}

interface LastExInner {
  src: string;
  srcFalse: string;
  fileTypeId: number;
}

interface LastFour {
  id: number;
  src: string;
  srcFalse: string;
  url: string;
  type: number;
}
